import { date_column_properties } from "../../BacklogTable/utils/backlog_datagrid_common_column_properties";
import { render_po_date_picker } from "../utils/po_datagrid_cell_renderer";
import { sample_types } from "./po_columns";

export const date_time_string_to_date = (date_time_string) => {
  // console.log({ date_time_string, d: new Date(date_time_string) });
  return new Date(date_time_string);
};

export const po_table_headers = {
  _id: {
    field: "_id",
    headerName: "ID",
    visible: false,
    width: 100,
  },
  material: {
    field: "material",
    headerName: "MATERIAL",
    visible: true,
    editable: false,
    width: 100,
  },
  material_description: {
    field: "material_description",
    headerName: "MATERIAL DESCRIPTION",
    visible: true,
    editable: false,
    width: 250,
  },
  batch_no: {
    field: "batch_no",
    headerName: "BATCH",
    visible: true,
    editable: false,
    width: 100,
  },
  stp_id: {
    field: "stp_id",
    headerName: "STP ID",
    visible: true,
    editable: false,
    width: 100,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FT007296", value: "FT007296" },
    //   { label: "FT003572", value: "FT003572" },
    //   { label: "FT003702", value: "FT003702" },
    //   { label: "FT005640", value: "FT005640" },
    //   { label: "FT010562", value: "FT010562" },
    //   { label: "FT006061", value: "FT006061" },
    //   { label: "FT008844", value: "FT008844" },
    //   { label: "FT010888", value: "FT010888" },
    // ]
  },
  order: {
    field: "order",
    headerName: "ORDER",
    isEditable: false,
  },
  unit: {
    field: "unit",
    headerName: "UNIT",
    isEditable: false,
  },
  "stor._loc.": {
    field: "stor._loc.",
    headerName: "STOR. LOC",
    width: 150,
    isEditable: false,
  },
  expected_delivery_date_by_production: {
    field: "expected_delivery_date_by_production",
    headerName: "EXPECTED DELIVERY DATE BY PRODUCTION",
    visible: true,
    editable: false,
    width: 300,
    type: "date",
    ...date_column_properties,
    renderCell: render_po_date_picker,
  },

  spec_id: {
    field: "spec_id",
    headerName: "SPEC ID",
    visible: true,
    editable: false,
    width: 150,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    // ]
  },
  market: {
    field: "market",
    headerName: "MARKET",
    visible: true,
    editable: false,
    width: 150,
  },
  sample_type: {
    field: "sample_type",
    headerName: "MATERIAL TYPE",
    visible: true,
    editable: false,
    width: 150,
    type: "singleSelect",
    valueOptions: [...sample_types],
  },
  expected_delivery_date_by_ip_qa: {
    field: "expected_delivery_date_by_ip_qa",
    headerName: "EXPECTED DELIVERY DATE BY IP QA",
    visible: true,
    editable: false,
    width: 250,
    type: "date",
    ...date_column_properties,
    renderCell: render_po_date_picker,
  },
  receiving_date_by_qc: {
    field: "receiving_date_by_qc",
    headerName: "RECEIVING DATE BY QC",
    visible: true,
    editable: false,
    width: 220,
    type: "dateTime",
    // ...date_column_properties,
    valueGetter: ({ value }) => {
      if (typeof value === "object") return value;
      return value && date_time_string_to_date(value);
    },
    renderCell: render_po_date_picker,
  },
  sample_collector: {
    field: "sample_collector",
    headerName: "SAMPLE COLLECTOR",
    isEditable: false,
    width: 200,
  },
  sample_receiver: {
    field: "sample_receiver",
    headerName: "SAMPLE RECEIVER",
    isEditable: false,
    width: 200,
  },
  storage_condition: {
    field: "storage_condition",
    headerName: "STORAGE CONDITION",
    isEditable: false,
    width: 200,
  },
};
